import Image from 'next/image';
import yourCompanyLogoWithPlus from '../../public/images/your-company-logo-with-plus.png';
import { imageLoader } from '../../helpers/contentful';

const ScreenWindow = () => (
  <div className="ScreenWindow">
    <div className="ScreenWindow-windowWrap">
      <img
        className="ScreenWindow-overlayImage"
        src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
        alt=""
      />
      <div className="ScreenWindow-logo">
        <Image
          unoptimized
          loader={imageLoader}
          src={yourCompanyLogoWithPlus}
          width="711px"
          height="343px"
          objectFit="contain"
          objectPosition="left"
          layout="responsive"
        />
      </div>
      <h3 className="ScreenWindow-title">
        The all-in-one
        <br />
        software to grow
        <br /> local businesses
      </h3>
      <div className="ScreenWindow-banner">
        <div className="ScreenWindow-banner-subtitle">Headline for startups</div>
        <div className="ScreenWindow-banner-titleWrapper">
          <svg className="ScreenWindow-banner-icon">
            <use xlinkHref="#icon-magic-small" />
          </svg>
          <div className="ScreenWindow-banner-title">The modern way to grow your startup</div>
        </div>
      </div>
    </div>
  </div>
);

export default ScreenWindow;
